import { updateWhenLocaleChanges as t } from "./localized-controller.js"; /**
                                                                          * @license
                                                                          * Copyright 2021 Google LLC
                                                                          * SPDX-License-Identifier: BSD-3-Clause
                                                                          */
var r = function r() {
  return function (e, o) {
    return e.addInitializer(t), e;
  };
};
export { r as localized };